// The server never renders `popover`, so every LiveView patch would strip it, close the
// overlay and make promoteOverlays reopen it — and opening a popover focuses its
// `autofocus` field, which pulled typing out of whatever field was being edited.
export function preserveOverlayPromotion(from, to) {
  if (from.nodeType !== 1 || from.dataset.aiosOverlayPortal !== 'true') return
  to.dataset.aiosOverlayPortal = 'true'
  if (from.hasAttribute('popover')) to.setAttribute('popover', from.getAttribute('popover'))
}

// Keep LiveView's DOM ownership while escaping clipping/containing blocks.
export function promoteOverlays(root) {
  for (const overlay of root.querySelectorAll('.seiva-modal-root,.aios-dialog,.seiva-contained-drawer,[data-overlay-scope="viewport"],[data-testid="committee-room-intro"]')) {
    if (typeof overlay.showPopover !== 'function' || overlay.dataset.aiosOverlayFallback === 'true') continue
    const open = overlay.matches(':popover-open')
    if (!overlay.getClientRects().length) {
      if (open) overlay.hidePopover()
      continue
    }
    if (overlay.dataset.aiosOverlayPortal !== 'true') overlay.dataset.aiosOverlayPortal = 'true'
    if (overlay.getAttribute('popover') !== 'manual') overlay.setAttribute('popover', 'manual')
    if (!open) {
      try { overlay.showPopover() } catch (_) {
        overlay.removeAttribute('popover')
        overlay.dataset.aiosOverlayFallback = 'true'
      }
    }
  }
}
